import React from 'react';
import reactDom from '../../../common/react/dom/index';
import Profile from '../../../components/frontend/profile/ProfileView';

export default function init() {
	reactDom(<Profile />, 'js-react-profile');
}
